import React from 'react';
import { Eyebrow, Button } from './UI';
import { AutoVideo } from './AutoVideo';
import { Phone, Mail, Clock, MessageCircle, Send } from 'lucide-react';
export const Contact = () => {
  return <section id="contact" className="relative py-[120px] overflow-hidden" data-id="element-77" data-mp="3161t81b1ovgj">
      {/* Background Video */}
      <div className="absolute inset-0 z-0" data-id="element-78" data-mp="2w88pdex7sdjf">
        <AutoVideo src="https://cdn.magicpatterns.com/uploads/fWKrLziAYDyxUuYVynDRTi/hf_20260506_151534_e280cd37-1545-428a-a30c-8bf31ff2eab2.mp4" className="w-full h-full object-cover opacity-100" data-id="element-79" data-mp="2w9bdxg72e3w6" />
        {/* Dark overlay to ensure text readability */}
        <div className="absolute inset-0 bg-gradient-to-t from-base-black/90 via-base-black/40 to-base-black/90" data-id="element-80" data-mp="3k3uxb6xenbfi"></div>
        <div className="absolute inset-0 bg-patriot-navy/10 mix-blend-overlay" data-id="element-81" data-mp="3f48kuzpehz7r"></div>
      </div>

      <div className="container mx-auto px-6 md:px-12 relative z-10" data-id="element-82" data-mp="ghnn82in97lt">
        <div className="text-center mb-16" data-id="element-83" data-mp="bouel3k21f4g">
          <Eyebrow data-id="element-84" data-mp="bnro2wqn9ep2">DIRECT COMMS</Eyebrow>
          <h2 className="text-5xl md:text-[64px] leading-[0.9] mb-4" data-id="element-85" data-mp="3jvbb8yn7etha">
            REACH THE{' '}
            <span className="text-acid-green" data-id="element-86" data-mp="3ouxov96y2bqm">BLACKOUT UNIT TEAM.</span>
          </h2>
          <p className="font-barlow text-lg text-text-body max-w-2xl mx-auto" data-id="element-87" data-mp="3b3svupy30hp9">
            Real operators. Real answers. No bots. No wait. We respond to every
            single message.
          </p>
        </div>

        <div className="flex flex-col lg:flex-row gap-16" data-id="element-88" data-mp="3141ymgi4zolh">
          {/* Left - Info */}
          <div className="w-full lg:w-1/2" data-id="element-89" data-mp="364g7g0rkb2kk">
            <p className="font-barlow text-[17px] text-text-body leading-[1.9] mb-10" data-id="element-90" data-mp="365hgy0sxjh06">
              "We're a team of operators and builders — not a faceless customer
              service department. When you contact BLACKOUT UNIT, a real person
              responds. Every time."
            </p>

            <div className="space-y-6 mb-10" data-id="element-91" data-mp="qaxqct93plyq">
              <div className="flex items-start gap-4" data-id="element-92" data-mp="uf5eopbnczwf">
                <div className="w-12 h-12 border border-acid-green flex items-center justify-center text-acid-green shrink-0" data-id="element-93" data-mp="ucj92v8bgugu">
                  <Phone size={20} data-id="element-94" data-mp="1ycqzuunhng6b" />
                </div>
                <div data-id="element-95" data-mp="1yb65b516bx8g">
                  <div className="font-barlow text-xs text-text-dimmed tracking-widest uppercase mb-1" data-id="element-96" data-mp="1yeu0e8m9orpa">
                    CALL DIRECT
                  </div>
                  <a href="tel:+13055550142" className="font-bebas text-2xl text-white hover:text-acid-green transition-colors" data-id="element-97" data-mp="1pd47szgnfmpx">
                    +1 (305) 555-0142
                  </a>
                </div>
              </div>

              <div className="flex items-start gap-4" data-id="element-98" data-mp="2d8q9wau5rqe3">
                <div className="w-12 h-12 border border-acid-green flex items-center justify-center text-acid-green shrink-0" data-id="element-99" data-mp="28aonbfxix8xv">
                  <Mail size={20} data-id="element-100" data-mp="35qavwv1ohwo6" />
                </div>
                <div data-id="element-101" data-mp="35rvt6sfdntpq">
                  <div className="font-barlow text-xs text-text-dimmed tracking-widest uppercase mb-1" data-id="element-102" data-mp="30zm5zk5nd7r5">
                    EMAIL SUPPORT
                  </div>
                  <a href="mailto:support@blackoutunit.com" className="font-bebas text-2xl text-white hover:text-acid-green transition-colors" data-id="element-103" data-mp="38cbpuvgf85fo">
                    support@blackoutunit.com
                  </a>
                </div>
              </div>

              <div className="flex items-start gap-4" data-id="element-104" data-mp="3m7x8mkw29szn">
                <div className="w-12 h-12 border border-acid-green flex items-center justify-center text-acid-green shrink-0" data-id="element-105" data-mp="3r8bf3yi0kuvk">
                  <Clock size={20} data-id="element-106" data-mp="17fvps42cxp" />
                </div>
                <div data-id="element-107" data-mp="4tidglzdpmn3">
                  <div className="font-barlow text-xs text-text-dimmed tracking-widest uppercase mb-1" data-id="element-108" data-mp="4ua9fxww1mdw">
                    HOURS OF OPERATION
                  </div>
                  <div className="font-inter text-sm text-white" data-id="element-109" data-mp="duyl4lyt7anm">
                    Mon–Fri: 9AM–7PM ET
                    <br data-id="element-110" data-mp="isrv7q38got6" />
                    Saturday: 10AM–4PM ET
                  </div>
                </div>
              </div>

              <div className="flex items-start gap-4" data-id="element-111" data-mp="559h5acrs5o6">
                <div className="w-12 h-12 border border-acid-green flex items-center justify-center text-acid-green shrink-0" data-id="element-112" data-mp="15r0wrvw8iro">
                  <MessageCircle size={20} data-id="element-113" data-mp="evayzkej4run" />
                </div>
                <div data-id="element-114" data-mp="9x11v498vh6e">
                  <div className="font-barlow text-xs text-text-dimmed tracking-widest uppercase mb-1" data-id="element-115" data-mp="9ykiwx2q5w98">
                    LIVE CHAT
                  </div>
                  <div className="font-inter text-sm text-white" data-id="element-116" data-mp="3ebr4h25396ov">
                    Available on this page — bottom right
                    <br data-id="element-117" data-mp="3sbsfvbizbwil" />
                    <span className="text-text-dimmed" data-id="element-118" data-mp="3scbp83ukdcl0">
                      Average response: under 3 minutes
                    </span>
                  </div>
                </div>
              </div>
            </div>

            <div className="bg-[#4CAF50]/10 border border-[#4CAF50]/20 p-4 flex items-start gap-3" data-id="element-119" data-mp="17jgm2dt22sxn">
              <div className="text-[#4CAF50] font-bold mt-0.5" data-id="element-120" data-mp="12oayzbnx387z">✓</div>
              <div data-id="element-121" data-mp="2kj1xm21sxpn5">
                <div className="font-barlow font-bold text-xs text-[#4CAF50] tracking-[2px] uppercase mb-1" data-id="element-122" data-mp="2kiifak88oz8l">
                  AVERAGE RESPONSE TIME
                </div>
                <div className="font-inter text-xs text-text-dimmed" data-id="element-123" data-mp="2bk6pulj407hq">
                  "Under 2 hours during business hours. Same-day response
                  guaranteed Mon–Fri."
                </div>
              </div>
            </div>
          </div>

          {/* Right - Form */}
          <div className="w-full lg:w-1/2" data-id="element-124" data-mp="389nuqya9ppid">
            <div className="bg-dark-1 border border-dark-3 p-8 md:p-10" data-id="element-125" data-mp="38biewadptdle">
              <h3 className="font-bebas text-2xl text-white mb-6" data-id="element-126" data-mp="2uh7ycgbvgpqf">
                SEND INTEL
              </h3>
              <form className="space-y-4" onSubmit={e => e.preventDefault()} data-id="element-127" data-mp="2zf9fuwtnggzs">
                <div className="grid grid-cols-2 gap-4" data-id="element-128" data-mp="3n5wqhpuy9kq1">
                  <input type="text" placeholder="First Name" className="w-full bg-base-black border border-dark-3 p-3 text-white font-inter text-sm focus:border-acid-green outline-none transition-colors" data-id="element-129" data-mp="3rx4zwlwa5637" />
                  <input type="text" placeholder="Last Name" className="w-full bg-base-black border border-dark-3 p-3 text-white font-inter text-sm focus:border-acid-green outline-none transition-colors" data-id="element-130" data-mp="n24btb7uuve" />
                </div>
                <input type="email" placeholder="Email Address" className="w-full bg-base-black border border-dark-3 p-3 text-white font-inter text-sm focus:border-acid-green outline-none transition-colors" data-id="element-131" data-mp="3e3sziarcmi97" />
                <input type="tel" placeholder="Phone (optional)" className="w-full bg-base-black border border-dark-3 p-3 text-white font-inter text-sm focus:border-acid-green outline-none transition-colors" data-id="element-132" data-mp="343imaq5bdau1" />

                <div className="relative" data-id="element-133" data-mp="1amcvdh14m2mx">
                  <select className="w-full bg-base-black border border-dark-3 p-3 text-text-dimmed font-inter text-sm focus:border-acid-green outline-none transition-colors appearance-none cursor-pointer" data-id="element-134" data-mp="1eo7wakf5ae06">
                    <option value="" disabled selected data-id="element-135" data-mp="1omfef6l6723r">
                      Select Subject...
                    </option>
                    <option value="order" data-id="element-136" data-mp="qzyedtl1yaeb">Order Status</option>
                    <option value="product" data-id="element-137" data-mp="vy00kndrypu0">Product Question</option>
                    <option value="warranty" data-id="element-138" data-mp="vy9swhmal92v">Warranty Claim</option>
                    <option value="return" data-id="element-139" data-mp="10w1phoxvtjde">Return / Exchange</option>
                    <option value="wholesale" data-id="element-140" data-mp="15njklwd84pqg">Wholesale Inquiry</option>
                    <option value="other" data-id="element-141" data-mp="15pmi11gphl57">Other</option>
                  </select>
                  <div className="absolute right-4 top-1/2 -translate-y-1/2 pointer-events-none text-text-dimmed" data-id="element-142" data-mp="885nq5tgh19r">
                    ▼
                  </div>
                </div>

                <textarea placeholder="Message" rows={4} className="w-full bg-base-black border border-dark-3 p-3 text-white font-inter text-sm focus:border-acid-green outline-none transition-colors resize-none" data-id="element-143" data-mp="32qdhgzceos0e"></textarea>

                <Button variant="primary" fullWidth className="mt-4" data-id="element-144" data-mp="36qe5nbpb4hkn">
                  <span className="inline-flex items-center justify-center gap-2" data-id="element-145" data-mp="3lnwo5wbe5yjn">
                    <Send size={14} strokeWidth={2.5} data-id="element-146" data-mp="3gplg9r4npy42" />
                    SEND MESSAGE
                  </span>
                </Button>
              </form>
            </div>
          </div>
        </div>
      </div>
    </section>;
};